<template>
  <li class="hiq-detail-planning-list__hit" data-link-box>
    <a class="hiq-detail-planning-list__hit-link" :href="hit.uri">
      <div
        class="hiq-detail-planning-list__hit-upper"
        style="position: relative"
      >
        <div v-html="hit.imageRendered"></div>
        <span
          v-if="hit.status"
          class="hiq-detail-planning-list__hit-status"
          style="position: absolute; top: 0.75rem; right: 0.75rem; z-index: 1; max-width: calc(100% - 1.5rem); padding: 0.35rem 0.65rem; border-radius: 0.2rem; background: #ffffff; color: #222222; font-size: 0.875rem; font-weight: 700; line-height: 1.2; box-shadow: 0 0.1rem 0.35rem rgba(0, 0, 0, 0.25)"
        >
          {{ hit.status }}
        </span>
      </div>
      <div class="hiq-detail-planning-list__hit-lower">
        <h2 class="hiq-detail-planning-list__hit-title">{{ hit.title }}</h2>
        <p class="hiq-detail-planning-list__hit-preamble">{{ hit.preamble }}</p>
      </div>
    </a>
  </li>
</template>
<script lang="ts">
import Vue from "vue";
import { ISearchHit } from "../store/state";
interface HitProps {
  hit: ISearchHit;
}

export default Vue.extend<{}, {}, {}, HitProps>({
  name: "Hit",
  props: {
    hit: {},
  },
});
</script>
